module.exports = __webpack_public_path__ + "microCampaignNoStatistics.svg?b628578b88139d8cd97c6741795cded0";